import { getFunctions, httpsCallable, connectFunctionsEmulator } from 'firebase/functions';
import { onAuthStateChanged } from 'firebase/auth';
import app, { auth, isLocalEmulator } from '../../firebase';

let functions;
export const observeEarningsIdentity = callback => onAuthStateChanged(auth, user => callback(user?.uid || null));
export async function loadWorkerEarnings(uid, cursor = null) {
  if (!uid || auth.currentUser?.uid !== uid) throw new Error('Worker identity changed.');
  if (!functions) {
    functions = getFunctions(app, 'us-central1');
    if (isLocalEmulator) connectFunctionsEmulator(functions, '127.0.0.1', 5001);
  }
  // Identity is obtained from the verified callable token, never a request UID.
  const response = await httpsCallable(functions, 'workerEarnings')({ cursor });
  if (auth.currentUser?.uid !== uid) throw new Error('Worker identity changed.');
  return response.data;
}
